/* eslint-disable jsx-a11y/media-has-caption */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classnames from 'classnames';
import { makeStyles, shorthands } from '@fluentui/react-components';

const useStyles = makeStyles({
  dynamicSizeContainer: {
    height: '100%',

    '& video': {
      maxWidth: '100%',
      maxHeight: '100%',
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
  videoOutlineGray: {
    '& video:focus': {
      ...shorthands.outline('2px', 'solid', 'gray'),
      outlineOffset: '1px',
    },
  },
  videoNormalContainer: {
    '& video::-webkit-media-controls-play-button:focus': {
      outlineOffset: '-2px',
    },
    '& video::-webkit-media-controls-pause-button:focus': {
      outlineOffset: '-2px',
    },
    '& video::-webkit-media-controls-volume-slider:focus': {
      outlineOffset: '-2px',
    },
    '& video::-webkit-media-controls-timeline:focus': {
      outlineOffset: '-2px',
    },
    '& video::-webkit-media-controls-mute-button:focus': {
      outlineOffset: '-2px',
    },
    '& video::-webkit-media-controls-fullscreen-button:focus': {
      outlineOffset: '-2px',
    },
    '& video::-webkit-media-controls-panel': {
      backgroundImage: 'linear-gradient(0deg,rgba(255, 255, 255, 0.8), transparent) !important',
      filter: 'brightness(1)',
      boxShadow: 'none !important',
    },
  },
});

// since the <video> didn't support the stream play directly, so will using one link in DownloadUrl instead of the url as src.
export const VideoPlaybackView = (props) => {
  const {
    height,
    width,
    src,
    thumbnailUrl,
    hideControls,
    onLoadedMetadata,
    onErrorHanler,
    isOutlineGray,
  } = props;

  const classes = useStyles();
  const useDynamicVideoSize = !(width > 0 || height > 0);

  const onError = useCallback((ev) => {
    const errorCode = ev && ev.target && ev.target.error.code;
    onErrorHanler(errorCode);
  }, [onErrorHanler]);

  return (
    <div className={classnames(useDynamicVideoSize && classes.dynamicSizeContainer, isOutlineGray && classes.videoOutlineGray, classes.videoNormalContainer, 'video-playback-view')}>
      <video
        width={width}
        height={height}
        poster={thumbnailUrl}
        controls={!hideControls}
        onLoadedMetadata={onLoadedMetadata}
        onError={onError}
        src={src}
        controlsList="nodownload nofullscreen"
        disablePictureInPicture
      />
    </div>);
};

VideoPlaybackView.propTypes = {
  isOutlineGray: PropTypes.bool,
  src: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
  hideControls: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
  onErrorHanler: PropTypes.func,
  onLoadedMetadata: PropTypes.func,
};

VideoPlaybackView.defaultProps = {
  isOutlineGray: false,
  thumbnailUrl: null,
  hideControls: false,
  width: undefined,
  height: undefined,
  onErrorHanler: _.noop,
  onLoadedMetadata: _.noop,
};
